import { useContext } from "react";
import { ProjectFilePlanContext } from "./project-file-plan-context-props";

const useProjectFilePlanContext = () => {
    const context = useContext(ProjectFilePlanContext);
    if (!context) {
        throw new Error('Must be used inside ProjectFilePlanContext');
    }

    return context;
}

export default useProjectFilePlanContext;